export class Planet {
    name = null;
    YugaRotation = 0; // sidereal rotations
    Rotation = 0;
    Sighra = 0;
    MeanPosition = 0;
    Apogee = 0;
    MandaCircumference = 0;
    SighraCircumference = 0;
    constructor() { }
}

export class Star extends Planet {
    constructor() {
        super();
        this.name = 'star';
    }
}


export class Sun extends Planet {
    constructor() {
        super();
        this.name = 'sun';
    }
}

export class Moon extends Planet {
    constructor() {
        super();
        this.name = 'moon';
    }
}


export class Mercury extends Planet {
    constructor() {
        super();
        this.name = 'mercury';
    }
}


export class Venus extends Planet {
    constructor() {
        super();
        this.name = 'venus';
    }
}


export class Mars extends Planet {
    constructor() {
        super();
        this.name = 'mars';
    }
}








export class Jupiter extends Planet {
    constructor() {
        super();
        this.name = 'jupiter';
    }
}








export class Saturn extends Planet {

    constructor() {
        super();
        this.name = 'saturn';
    }
}








export class Candrocca extends Planet {
    constructor() {
        super();
        this.name = 'candrocca';
    }
}








export class Rahu extends Planet {
    constructor() {
        super();
        this.name = 'rahu';
    }
}
